import React from "react";
import {GovNav} from "@gov-design-system-ce/react";

export interface NavProps {
    children: React.ReactNode;
}

export default function Nav(props: NavProps) {
    const {children} = props;

    return (
        <GovNav>
            {children}
        </GovNav>
);
}